import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { BaseURL, GetRandomInt, fetchTimeout, encodeJobNumber } from "../../components/Common";
import { Palette } from "../../AppConfig";
import Dialog_SendToLyves from "./Dialog_SendToLyves";
import MessageSupport from "./MessageSupport";
import * as APP from "../../redux_store/appState";
import { API_BASE } from "../../AppConfig";

import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import Icon from "@material-ui/core/Icon";
import ContactSupportIcon from "@material-ui/icons/ContactSupport";
import BuildOutlinedIcon from "@material-ui/icons/BuildOutlined";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { MobileScreenShare } from "@material-ui/icons";
import EditNoteIcon from "@mui/icons-material/EditNote";
import WorkHistoryIcon from "@mui/icons-material/WorkHistory";
import { Tooltip } from "@material-ui/core";
import { QRCodeSVG } from "qrcode.react";

const { convertJobStateToIni } = require("../../components/Common_Conversions");

const useStyles = makeStyles({
    root: {},
    drawer: {
        width: "80px",
        flexShrink: 0,
        whiteSpace: "nowrap",
        zIndex: 100,
        paddingTop: "78px",
        display: "inline",
        backgroundColor: "#F4F4F4",
        borderRight: "1px solid rgba(0, 0, 0, 0.2)",
    },
    selected: {
        background: "#002D6222",
        borderRight: "4px solid " + Palette.FieldersBlue,
        "&:hover": {
            backgroundColor: "#6B879988",
        },
    },
    imageIcon: {
        height: "80%",
        width: "80%",
    },
    iconRoot: {
        textAlign: "center",
        width: "36px",
        height: "36px",
    },
    iconText: {
        fontSize: "12px",
        textAlign: "center",
    },

    spacer: {
        flexGrow: 1,
    },
});

const StyledListItem = withStyles({
    root: {
        color: "rgba(0, 0, 0, 0.54)",
    },
})(ListItem);

const StyledListItemIcon = withStyles({
    root: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "48px",
        minWidth: "48px",
        color: Palette.FieldersBlue,
        marginTop: "4px",
    },
})(ListItemIcon);

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
};

export default function Designer_ToolBar(props) {
    const { setShowJobNotes, setShowAuditTrail, isBomOpen } = props;

    const SELECT_POINT = useSelector((state) => state.app.designer?.designer2D[APP.SELECT_POINT]);
    const [ViewARModal, setViewARModal] = React.useState(false);
    const [openLyves, setOpenLyves] = React.useState(false);
    const user = useSelector((state) => state.app.user);
    const config = useSelector((state) => state.app);
    const job = useSelector((state) => state.job);
    const app = useSelector((state) => state.app);
    const dispatch = useDispatch();
    const classes = useStyles();

    const [showMessageSupport, setShowMessageSupport] = React.useState(false);

    let url_base = window.location.href.split("app/")[0];
    let brandRedirect = url_base + "app?3d-viewer&job=" + encodeJobNumber(job?.id);

    const ViewAR = () => {
        setViewARModal(!ViewARModal);
    };

    const GetEngineering = async () => {
        const job_data = job;
        let api_url = API_BASE() + "document/" + job_data.id + "/" + "Engineering Spreadsheet";

        let user_id = app.user.id;
        let job_ini = convertJobStateToIni(job_data, app, "", config);
        let material_list = job_data?.QuoteParameters?.BOM?.OrderList;
        if (!material_list || !material_list?.items) material_list = job_data?.QuoteParameters?.BOM?.SystemList;

        let request_id = Date.now() + "_" + GetRandomInt(1000, 9999);

        dispatch(APP.setDesignerLoadingBackdrop("Getting Engineering for #" + job.id));

        return fetchTimeout(
            api_url,
            {
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    document_type: "Engineering Spreadsheet",
                    user_id: user_id,
                    job_id: job_data.id,
                    job: job_ini,
                    order_list: material_list,
                    wind_data: job_data?.SiteParameters?.WindData,
                    brand: window.LYSAGHT ? "Lysaght" : "Fielders",
                    job_raw: job_data,
                    request_id: request_id,
                }),
            },
            120000
        )
            .then(async (response) => {
                if (response?.status && response.status >= 200 && response.status <= 300) {
                    dispatch(APP.setDesignerLoadingBackdrop());
                    let filename = await response.text();

                    let document_to_show_url = API_BASE() + "document/" + job.id + "/";

                    var element = document.createElement("a");
                    element.setAttribute("href", document_to_show_url + filename);
                    element.setAttribute("download", filename);

                    element.style.display = "none";
                    document.body.appendChild(element);

                    element.click();
                } else {
                    throw {
                        message: "Could not generate Engineering at this time. Please wait a moment and try again.",
                    };
                }
            })
            .catch((e) => {
                dispatch(APP.setDesignerLoadingBackdrop());

                dispatch({
                    type: APP.SHOW_DESIGNER_MESSAGE,
                    message: "(1) Error getting Engineering - " + e?.message,
                });

                dispatch(APP.setDesignerLoadingBackdrop("Getting Engineering for #" + job.id));
            });
    };

    const orderStatus = (job?.OrderStatus || "").toUpperCase();
    const locked = orderStatus === "PENDING" || job?.App?.Locked;
    let has_order_items = false;

    if (props?.job?.QuoteParameters?.BOM?.OrderList?.items)
        has_order_items = props?.job?.QuoteParameters?.BOM?.OrderList?.items.length > 0;

    let disabled = false;

    // Ensures if loaded from job, documents are ready for backend
    React.useEffect(() => {
        if (job?.App?.Locked !== true) {
            if (app?.pricefile) {
                disabled = SELECT_POINT;
                dispatch({
                    type: APP.TOGGLE_DESIGNER,
                    parameter: APP.SHOW_LOADING_BAR,
                    value: false,
                });
            }
        }
    }, [app?.pricefile, job?.App]);

    let disable_tooltip_text = "";
    if (!app?.pricefile) {
        disabled = true;
        disable_tooltip_text = "Modules are still loading... please wait...";
    }

    if (job?.App?.Locked) {
        disabled = true;
        disable_tooltip_text = "App bar is locked";
    }

    return (
        <Drawer
            variant="permanent"
            className={classes.drawer}
            classes={{ paper: classes.drawer }}
            open={false}
            disabled={disabled}
        >
            <List style={{ display: "flex", flexDirection: "column", height: "100%" }}>
                <Tooltip title={disable_tooltip_text}>
                    <StyledListItem
                        button
                        key={"BOM"}
                        id="System BOM"
                        disabled={disabled || isBomOpen}
                        onClick={() => props.toggleBomOpen()}
                    >
                        <StyledListItemIcon>
                            <Icon classes={{ root: classes.iconRoot }}>
                                {window.FIELDERS ? (
                                    <img className={classes.imageIcon} src={BaseURL("/images/bom.svg")} />
                                ) : (
                                    <img className={classes.imageIcon} src={BaseURL("/images/bomLysaght.svg")} />
                                )}
                            </Icon>
                            <div className={classes.iconText}>
                                {has_order_items ? "Custom" : "System"}
                                <br />
                                BOM
                            </div>
                        </StyledListItemIcon>
                    </StyledListItem>
                </Tooltip>

                {user?.Role !== 92 && (
                    <Tooltip title={disable_tooltip_text}>
                        <StyledListItem
                            id="System BOM"
                            button
                            key={"Quote"}
                            disabled={disabled || isBomOpen}
                            onClick={() => props.toggleQuoteOpen()}
                        >
                            <StyledListItemIcon>
                                <Icon classes={{ root: classes.iconRoot }}>
                                    {window.FIELDERS ? (
                                        <img className={classes.imageIcon} src={BaseURL("/images/quote.svg")} />
                                    ) : (
                                        <img className={classes.imageIcon} src={BaseURL("/images/quoteLysaght.svg")} />
                                    )}
                                </Icon>
                                <div className={classes.iconText}>Quote</div>
                            </StyledListItemIcon>
                        </StyledListItem>
                    </Tooltip>
                )}

                {user?.id.includes("diego.portela@bluescopesteel.com.lld") && (
                    <Tooltip title={disable_tooltip_text}>
                        <StyledListItem
                            id="Get Pricing"
                            button
                            key={"Get Pricing"}
                            disabled={disabled}
                            onClick={() => props.toggleQuoteOpen(true)}
                        >
                            <StyledListItemIcon>
                                <Icon classes={{ root: classes.iconRoot }}>
                                    {window.FIELDERS ? (
                                        <img className={classes.imageIcon} src={BaseURL("/images/quote.svg")} />
                                    ) : (
                                        <img className={classes.imageIcon} src={BaseURL("/images/quoteLysaght.svg")} />
                                    )}
                                </Icon>
                                <div className={classes.iconText}>Get Pricing</div>
                            </StyledListItemIcon>
                        </StyledListItem>
                    </Tooltip>
                )}

                <Tooltip title={disable_tooltip_text}>
                    <StyledListItem
                        button
                        key={"Documents"}
                        disabled={disabled || isBomOpen}
                        onClick={() => props.toggleDocumentOpen()}
                    >
                        <StyledListItemIcon>
                            <Icon classes={{ root: classes.iconRoot }}>
                                {window.FIELDERS ? (
                                    <img className={classes.imageIcon} src={BaseURL("/images/documents.svg")} />
                                ) : (
                                    <img className={classes.imageIcon} src={BaseURL("/images/documentsLysaght.svg")} />
                                )}
                            </Icon>
                            <div className={classes.iconText}>Documents</div>
                        </StyledListItemIcon>
                    </StyledListItem>
                </Tooltip>

                {user?.Role < 90 && (
                    <StyledListItem
                        disabled={locked || disabled || isBomOpen}
                        button
                        key={"Order"}
                        onClick={() => {
                            props.toggleOrderOpen();
                        }}
                    >
                        <StyledListItemIcon>
                            <Icon classes={{ root: classes.iconRoot }}>
                                {window.FIELDERS ? (
                                    <img className={classes.imageIcon} src={BaseURL("/images/order.svg")} />
                                ) : (
                                    <img className={classes.imageIcon} src={BaseURL("/images/orderLysaght.svg")} />
                                )}
                            </Icon>
                            <div className={classes.iconText}>Order</div>
                        </StyledListItemIcon>
                    </StyledListItem>
                )}

                {user?.Role >= 90 && user?.Role !== 92 && (
                    <StyledListItem
                        button
                        key={"Order"}
                        disabled={disabled || isBomOpen}
                        onClick={() => {
                            locked ? setShowMessageSupport("Order Review") : props.toggleOrderOpen();
                        }}
                    >
                        <StyledListItemIcon>
                            <Icon classes={{ root: classes.iconRoot }}>
                                {window.FIELDERS ? (
                                    <img className={classes.imageIcon} src={BaseURL("/images/order.svg")} />
                                ) : (
                                    <img className={classes.imageIcon} src={BaseURL("/images/orderLysaght.svg")} />
                                )}
                            </Icon>
                            <div className={classes.iconText}>
                                Order{" "}
                                {locked ? (
                                    <>
                                        <br />
                                        Review
                                    </>
                                ) : (
                                    ""
                                )}
                            </div>
                        </StyledListItemIcon>
                    </StyledListItem>
                )}

                {user?.Role >= 90 && user?.Role !== 92 && (
                    <StyledListItem
                        button
                        key={"LYVES"}
                        disabled={disabled}
                        onClick={() => {
                            setOpenLyves(true);
                        }}
                    >
                        <StyledListItemIcon>
                            <Icon classes={{ root: classes.iconRoot }}>
                                {window.FIELDERS ? (
                                    <img className={classes.imageIcon} src={BaseURL("/images/lyves.svg")} />
                                ) : (
                                    <img className={classes.imageIcon} src={BaseURL("/images/lyvesLysaght.svg")} />
                                )}
                            </Icon>
                            <div className={classes.iconText}>
                                {window.location.href.includes("sit.") ? "ERP" : "LYVES"}
                            </div>
                        </StyledListItemIcon>
                    </StyledListItem>
                )}

                {(user?.Role === 92 || user?.Role >= 99) && (
                    <StyledListItem
                        button
                        key={"Engineering"}
                        disabled={disabled}
                        onClick={() => {
                            GetEngineering();
                        }}
                    >
                        <StyledListItemIcon>
                            <Icon classes={{ root: classes.iconRoot }}>
                                {window.FIELDERS ? (
                                    <BuildOutlinedIcon
                                        style={{ fontSize: 30 }}
                                        sx={{ color: window.FIELDERS ? undefined : "black" }}
                                    />
                                ) : (
                                    <img
                                        className={classes.imageIcon}
                                        src={BaseURL("/images/engineeringLysaght.svg")}
                                    />
                                )}
                            </Icon>
                            <div className={classes.iconText}>
                                Download
                                <br />
                                Engineering
                            </div>
                        </StyledListItemIcon>
                    </StyledListItem>
                )}

                {(user?.Role === 92 || user?.Role >= 99) && (
                    <StyledListItem
                        button
                        key={"AR"}
                        disabled={disabled}
                        onClick={() => {
                            ViewAR();
                        }}
                    >
                        <StyledListItemIcon>
                            <Icon classes={{ root: classes.iconRoot }}>
                                <MobileScreenShare sx={{ color: window.FIELDERS ? undefined : "black" }} />
                            </Icon>
                            <div className={classes.iconText}>
                                Mobile 3D
                                <br />
                                View
                            </div>
                        </StyledListItemIcon>
                    </StyledListItem>
                )}

                <Dialog_SendToLyves
                    open={openLyves}
                    onClose={() => {
                        setOpenLyves(false);
                    }}
                />

                {user?.Role >= 90 && (
                    <StyledListItem
                        button
                        key={"Notes"}
                        disabled={disabled}
                        onClick={() => {
                            setShowJobNotes(true);
                        }}
                    >
                        <StyledListItemIcon>
                            <Icon classes={{ root: classes.iconRoot }}>
                                <EditNoteIcon
                                    style={{ fontSize: 30 }}
                                    sx={{ color: window.FIELDERS ? undefined : "black" }}
                                />
                            </Icon>
                            <div className={classes.iconText}>Job Notes</div>
                        </StyledListItemIcon>
                    </StyledListItem>
                )}

                {user?.Role >= 99 && (
                    <StyledListItem
                        button
                        key={"Audit"}
                        disabled={disabled}
                        onClick={() => {
                            setShowAuditTrail(true);
                        }}
                    >
                        <StyledListItemIcon>
                            <Icon classes={{ root: classes.iconRoot }}>
                                <WorkHistoryIcon
                                    style={{ fontSize: 25 }}
                                    sx={{ color: window.FIELDERS ? undefined : "black" }}
                                />
                            </Icon>
                            <div className={classes.iconText}>Audit Trail</div>
                        </StyledListItemIcon>
                    </StyledListItem>
                )}

                <div className={classes.spacer} />

                <StyledListItem
                    button
                    key={"Support"}
                    disabled={disabled}
                    onClick={() => setShowMessageSupport(!showMessageSupport)}
                >
                    <StyledListItemIcon>
                        <Icon classes={{ root: classes.iconRoot }}>
                            {window.FIELDERS ? (
                                <ContactSupportIcon
                                    style={{ fontSize: 30 }}
                                    sx={{ color: window.FIELDERS ? undefined : "black" }}
                                />
                            ) : (
                                <img className={classes.imageIcon} src={BaseURL("/images/supportLysaght.svg")} />
                            )}
                        </Icon>
                        <div className={classes.iconText}>SUPPORT</div>
                    </StyledListItemIcon>
                </StyledListItem>
            </List>

            {showMessageSupport && (
                <MessageSupport
                    style={{ display: showMessageSupport ? "flex" : "none" }}
                    mode={showMessageSupport}
                    setShowMessageSupport={setShowMessageSupport}
                />
            )}

            <Modal
                open={ViewARModal}
                onClose={() => {
                    setViewARModal(false);
                }}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <>
                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            View Model on Device
                        </Typography>
                        <div className={classes.qrcode_container}>
                            <QRCodeSVG value={brandRedirect} size={88} />
                            <div className={classes.qrcode_note}>
                                <span>Scan this QR code or click </span>
                                <a href={brandRedirect} target="_blank" rel="noreferrer">
                                    here
                                </a>
                                <span> to view this design in 3D and see how it would improve your place! </span>
                                <span>This QR Code can be added to your quote!</span>
                            </div>
                        </div>
                    </>
                </Box>
            </Modal>
        </Drawer>
    );
}
